import React, { useEffect } from 'react';
import BodyClassName from 'react-body-classname'
import { isMobile } from '../../helpers/helpers'
import './VehiclePage.scss'
import Headline from '../../components/Title/Headlines'
import VehicleTabs from '../../components/VehicleTabs/VehicleTabs'
import RegistartionTab from '../../components/VehicleTabs/Tabs/RegistrationTab';
import SerieNumberTab from '../../components/VehicleTabs/Tabs/SerieNumberTab';
import ModelTab from '../../components/VehicleTabs/Tabs/ModelTab';
import CONSTANTS from '../../Constants';
import useBodyClass from '../../custom-Hooks/useBodyClass';
import { pushToGTMTracker } from '../../helpers/trackerManager';
import { useSelector } from 'react-redux';

const ActivateTabImmat = (!!Number(CONSTANTS.SITE_CONFIG.ActivateTabImmat))
const ActivateTabNumSerie = (!!Number(CONSTANTS.SITE_CONFIG.ActivateTabNumSerie))
const ActivateTabModele = (!!Number(CONSTANTS.SITE_CONFIG.ActivateTabModele))

const VehiclePage = () => {
    const dealer = useSelector(state => state.ndel_store.dealer)
    useEffect(() => {
        pushToGTMTracker('vehicle-page', window.siteConfig.quotingVehicule.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()), dealer)
        window.scrollTo(0, 0)
    }, [])
    useBodyClass(`page-vehicle`)
    return (
        <>
            <Headline
                Title={CONSTANTS.LABELS.vehicule_title}
                SubTitle={!isMobile() ? (CONSTANTS.LABELS.vehicule_quote_subtitle1) : (CONSTANTS.LABELS.vehicule_subtitle)}
                Text={CONSTANTS.LABELS.vehicule_quote_subtitle2}
            />
            <div className='content-wrapper'>
                <div className='content-container'>
                    <VehicleTabs>
                        {ActivateTabImmat && <div label={CONSTANTS.LABELS.vehicule_plate_title} order='1'>
                            <RegistartionTab />
                        </div>}
                        {ActivateTabNumSerie && <div label={CONSTANTS.LABELS.vehicule_serial_title} order={'2'}>
                            <SerieNumberTab />
                        </div>}
                        {ActivateTabModele && <div label={CONSTANTS.LABELS.vehicule_model_title} order={'3'}>
                            <ModelTab />
                        </div>
                        }
                    </VehicleTabs>
                </div>

            </div>
        </>
    );

}

export default VehiclePage;
